import React from 'react';

function Contact() {
  return (
    <section id="contact" style={{ padding: '6rem 2rem', textAlign: 'center' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>
        <p className="section-label" style={{ justifyContent: 'center', display: 'flex' }}>
          04. Say Hello
        </p>
        <h2 className="section-title" style={{ textAlign: 'center' }}>
          Get In <span className="gradient-word">Touch</span>
        </h2>
        <p style={{ color: 'var(--muted)', maxWidth: 520, margin: '0 auto 2.5rem', fontSize: '1.02rem' }}>
          I'm always open to new opportunities, collaborations, or a good conversation about tech and design.
          Whether you're a recruiter, a fellow developer, or someone with an interesting project — my inbox is open!
        </p>
        <div className="d-flex gap-3 justify-content-center flex-wrap">
          <a href="mailto:zdjer050@uottawa.ca" className="btn-primary-custom">
            Say Hello ✉️
          </a>
          <a href="https://www.linkedin.com/in/zachary-djerdjouri-902142212/" target="_blank" rel="noreferrer" className="btn-outline-custom">
            LinkedIn ↗
          </a>
          <a href="https://github.com/Zachdj27" target="_blank" rel="noreferrer" className="btn-outline-custom">
            GitHub ↗
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
